<app-header class="non-transparent" />

<main id="lbx-wrapper">
  @if (productsPage(); as productsPage) {
    @if (shouldDisplayHeader()) {
      <app-product-list-header [metaData]="productsPage.meta"> </app-product-list-header>
    }

    <div class="options" [style.visibility]="isSearch() ? 'hidden' : 'visible'">
      <div class="filter-options" *transloco="let t">
        <button
          class="filter-button"
          app-button
          (click)="filtersService.isFiltersOpen.set(true)"
        >
          {{ t('Filter') }}

          <svg-icon key="filters" />
        </button>
        @if (productsPage.meta.totalCount; as totalCount) {
          <span class="count"> {{ t('Selected products') }}: {{ totalCount }} </span>
        }
      </div>

      <app-dropdown
        *transloco="let t"
        [label]="t('Sort by')"
        [children]="dropdownOptions"
        [value]="sortDropdownValue"
        (valueChange)="onSortChange($event)"
        searchable="false"
      />
    </div>

    @if (isLoading()) {
      <div class="products-grid" [class.loading]="isLoading()">
        @for (_ of placeholders; track $index) {
          <app-product-list-item [item]="_"></app-product-list-item>
        }
      </div>
    } @else {
      @if (productsPage.meta.count > 0) {
        <div class="products-grid" [class.loading]="isLoading()">
          @for (item of products(); track item.id; let index = $index) {
            <app-product-list-item
              [item]="item"
              (selected)="onItemSelected(item, index)"
            ></app-product-list-item>
          }
        </div>
      } @else {
        <div class="products-not-found" *transloco="let t">
          <p>
            {{ t('No products found matching the selected search criteria.') }}
          </p>

          <img src="/assets/not-found/error-image.jpg" alt="" width="607" height="276" />
          <a app-button [routerLink]="'/' | addLocale">
            {{ t('Go to the homepage') }}
          </a>
        </div>
      }
    }

    <aside>
      <app-backdrop
        [isVisible]="filtersService.isFiltersOpen()"
        (closed)="filtersService.isFiltersOpen.set(false)"
      >
        <app-slide-in [isVisible]="filtersService.isFiltersOpen()">
          <app-filters
            [filters]="filters()"
            (filtersChange)="onFiltersChange($event)"
            (clear)="onFiltersClear()"
            (cancelClick)="filtersService.isFiltersOpen.set(false)"
            [sorting]="sorting()"
          ></app-filters>
        </app-slide-in>
      </app-backdrop>
    </aside>

    @if (productsPage.meta.count > 0) {
      <app-paginator
        [current]="currentPage()"
        [total]="productsPage.meta.totalPages"
      ></app-paginator>
    }
  }
</main>

<app-footer></app-footer>
